import { render } from "./DialogDuringMaintenance.vue?vue&type=template&id=6c31ff52"
import script from "./DialogDuringMaintenance.vue?vue&type=script&lang=js"
export * from "./DialogDuringMaintenance.vue?vue&type=script&lang=js"
script.render = render

export default script